<template>
  <NuxtLink
    class="teaser link teaser-default"
    :to="`/projekte/${project.slug}`"
  >
    <DatoAsset
      v-if="project.smallImage"
      fade-in="on-intersection"
      class="figure asset -hover-enabled"
      :asset="project.smallImage as DatoAssetDto"
      :hide-copyright="true"
      sizes="(max-width: 799px) 88vw, 30vw"
    />
    <div class="asset placeholder" v-else></div>
    <p class="title">{{ project.title }}</p>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { ProjectFragment } from '#gql';
import DatoAsset from '~/dato/DatoAsset.vue';
import type { DatoAssetDto } from '~/dato/dato';

const props = defineProps<{
  project: ProjectFragment;
}>();
</script>

<style scoped lang="scss"></style>
